import { render, staticRenderFns } from "./UserFeaturePieECharts.vue?vue&type=template&id=67fbbc04&scoped=true&"
import script from "./UserFeaturePieECharts.vue?vue&type=script&lang=js&"
export * from "./UserFeaturePieECharts.vue?vue&type=script&lang=js&"
import style0 from "./UserFeaturePieECharts.vue?vue&type=style&index=0&id=67fbbc04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fbbc04",
  null
  
)

export default component.exports